import React, { useRef, useState } from "react";
import Tippy from "@tippyjs/react";
import { Instance, Props } from "tippy.js";

export interface ContextMenuOptions {
  items?: (close: () => void) => React.ReactNode,
  //forwardedRef?: React.RefObject<HTMLDivElement>
  children?: React.ReactElement;
};

interface MenuPosition {
  x: number;
  y: number;
}

// Tippy.js cannot be wrapped on custom component (Scroller in this case)
// a recommended way is to use forwardRef to extract a reference from child component, but it gets complicated really quickly
// quite dirty and cheap workaround is to add a <span> wrapper, which also works well.
// https://github.com/atomiks/tippyjs-react/issues/71

export const ContextMenu = ({ items, children }: ContextMenuOptions) => {
  const [position, setPosition] = useState<MenuPosition>({ x: 0, y: 0 });
  const internal = useRef<Instance<Props> | null>(null);

  if (!items)
    return <>{children}</>;

  return <Tippy
    content={items(internal.current ? internal.current.hide : () => { })}
    arrow={false}
    animation={false}
    placement="right-start"
    trigger="contextmenu"
    onTrigger={(instance, event: any) => {
      setPosition({ x: event.clientX, y: event.clientY });
      internal.current = instance;
    }}
    interactive={true}
    offset={[0, 0]}
    getReferenceClientRect={() => ({
      width: 0,
      height: 0,
      top: position.y,
      bottom: position.y,
      left: position.x,
      right: position.x,
      x: position.x,
      y: position.y,
      toJSON: () => { }
    })}
  >
    <div style={{ width: "100%", height: "100%" }}>
      {children}
    </div>
  </Tippy>
}
